import PropTypes from "prop-types";

export const FormIntro = ({ title, subtitle, info }) => {
  return (
    <div className="form-intro w-full max-w-xs mx-auto text-center">
      <div className="form-intro__title text-2xl font-bold" dangerouslySetInnerHTML={{ __html: title }}></div>
      <div className="form-intro__subtitle mt-8 text-lg" dangerouslySetInnerHTML={{ __html: subtitle }}></div>
      {info && (
        <div className="form-intro__info my-8 text-xxs text-center" dangerouslySetInnerHTML={{ __html: info }}></div>
      )}
    </div>
  );
};

FormIntro.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  info: PropTypes.string,
};




